import { makeStyles } from '@material-ui/core';
import atgLogo from '../../assets/img/atg-neue-white.png';

const useStyles = makeStyles({
  path: {
    width: '75%',
    fill: '#7df3e1',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img src={atgLogo} alt="logo" className={classes.path} />;
};

export default LogoIcon;
